import React from 'react';
import {
    Button,
    FormControl,
    TextField,
} from '@mui/material';
import { Form, Label } from 'reactstrap';
import "./RulerPage.css";
import { useCreateRuler } from '../../hooks/useRulers';

function RulerCreation(selectedCompProp){
    const createRuler = useCreateRuler();
    const [serialNumber, setSerialNumber] = React.useState();
    const [notes, setNotes] = React.useState('');
    const [selectedComp] = React.useState(selectedCompProp.selectedCompProp);

    ///create ruler
    function submitRuler() {
        let numbArray = serialNumber.split('/')

        for (let i = 0; i < numbArray?.length; i++) {
            const rulerData = {
                rulerSerialNumber: `EvanG3-${numbArray[i]}`,
                rulerNotes: notes,
                userId: selectedComp
            }

            createRuler.mutate(rulerData);
        }
    };

    return(
        <div>
            <h1>Ruler Management</h1>
            <Form style={{ width: "100%", margin: 'auto' }}>
                <Label>Enter all Rulers Sold Into the Botmark Management System.</Label>
                <br />
                <div style={{ display: 'flex', flexDirection:'column'}}>
                    <FormControl className="rulerSubDiv" sx={{ m: 1 }} style={{ padding: 20 }}>
                        <Label style={{ padding: 10 }} htmlFor="outlined-adornment-amount"><b>Ruler Serial Number #</b></Label>
                        <Label style={{ padding: 10 }} htmlFor="outlined-adornment-amount">Please enter the last 6 digits of the Serial Number exactly as it appears on the EvanG3 Electronic Detailer. If you are entering more than one ruler please separate with a / .</Label>
                        <Label style={{ padding: 10 }} htmlFor="outlined-adornment-amount">Example: 000000 or 000000/000001</Label>
                        <TextField
                            className="rulerInput"
                            multiline rows={8} 
                            id="outlined-adornment-amount"
                            onChange={(event) => setSerialNumber(event.target.value)}
                        />
                    </FormControl>
                    <p>**At the moment if you enter more than one ruler the same note will be applied to the whole group.**</p>
                    <FormControl className="rulerSubDiv" style={{ padding:20 }}>
                        <Label htmlFor="outlined-adornment-amount">Ruler Notes</Label>
                        <TextField className="rulerInput" multiline rows={8} value={notes} onChange={(event) => setNotes(event.target.value)}></TextField>
                    </FormControl>
                </div>
                <br />
                <Button style={{margin:20, width:"50%"}} color="primary" variant="contained" onClick={() => submitRuler()}>
                    Generate
                </Button>
            </Form>
        </div>
    )
};

export default RulerCreation;
